import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData, getList, deleteData, editData } from '../../helpers/fackBackend_Helper';

function* getApiKeyListResponse({ dealerId }) {
    try {
        const response = yield call(editData, '/getApiKey/' + dealerId);
        if (response.response.Status) {
            yield put(actions.getApiKeySuccess(response.response.Data));
        } else {
            yield put(actions.getApiKeyFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getApiKeyFailed(error));
    }
}

function* addUpdateApiKeyResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/addUpdateApiKey', data);
        if (response.response.Status) {
            const responseList = yield call(editData, '/getApiKey/'+ data?.dealerId);
            if (responseList.response.Status) {
                yield put(actions.addUpdateApiKeySuccess(response.response.Message, responseList.response.Data));
            } else {
                yield put(actions.addUpdateApiKeyFailed(response.response.Message));
            }
        } else {
            yield put(actions.addUpdateApiKeyFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.addUpdateApiKeyFailed(error));
    }
}


export default function* rootSaga() {
    yield all([takeEvery(actions.GET_API_KEY_BY_DEALER_ID, getApiKeyListResponse)]);
    yield all([takeEvery(actions.ADD_UPDATE_API_KEY, addUpdateApiKeyResponse)]);
}
